"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSwitchStyles = void 0;
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const classnames_1 = __importDefault(require("classnames"));
const polished_1 = require("polished");
const _1 = require("../.");
/**
 * A single switcher that can be a visual alternative for checkbox.
 * Operates on a boolean value.
 */
const Switch = ({ name, value, text, mandatory, setValue, }) => {
    const classes = (0, exports.useSwitchStyles)();
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("label", { className: (0, classnames_1.default)(classes.label, 'rfc-checkitem'), htmlFor: name },
            react_1.default.createElement("input", { type: 'checkbox', name: name, className: classes.input, id: name, checked: value, onChange: e => setValue(name, e.target.checked, mandatory, { touched: true }) }),
            " ",
            text)));
};
exports.useSwitchStyles = (0, react_jss_1.createUseStyles)((theme) => {
    const inputSize = 20;
    return {
        label: {
            display: 'flex',
            position: 'relative',
            textAlign: 'left',
            alignItems: 'flex-start',
            cursor: 'pointer',
            minHeight: inputSize + 4,
        },
        input: {
            position: 'relative',
            minWidth: inputSize * 1.67,
            height: inputSize,
            display: 'inline-block',
            backgroundColor: theme.colors.inputBg,
            margin: '0 10px 0 0',
            padding: 0,
            borderRadius: inputSize / 2,
            '-webkit-appearance': 'none',
            border: `1px solid ${(0, polished_1.darken)(0.2, theme.colors.inputBorder)}`,
            outline: 'none',
            verticalAlign: 'middle',
            transform: (0, _1.calculateInputTranslation)(theme.typography.inputFontSize, inputSize),
            cursor: 'pointer',
            transition: 'background-color 100ms ease-in 25ms',
            '&::after': {
                content: '""',
                display: 'block',
                boxSizing: 'border-box',
                width: inputSize,
                height: inputSize,
                position: 'absolute',
                left: -1,
                top: -1,
                backgroundColor: theme.colors.inputBorder,
                border: `1px solid ${(0, polished_1.darken)(0.2, theme.colors.inputBorder)}`,
                borderRadius: '50%',
                transition: 'left 150ms ease-in',
            },
            '&:checked': {
                backgroundColor: theme.colors.success,
                '&::after': {
                    left: 'calc(100% - 19px)',
                },
            },
        },
    };
});
exports.default = (0, _1.withFormControl)(Switch);
